import { render, staticRenderFns } from "./ProductsCourtesy.vue?vue&type=template&id=37f4c0e1&"
import script from "./ProductsCourtesy.vue?vue&type=script&lang=js&"
export * from "./ProductsCourtesy.vue?vue&type=script&lang=js&"
import style0 from "./ProductsCourtesy.vue?vue&type=style&index=0&id=37f4c0e1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports